import { render, staticRenderFns } from "./ButtonC.vue?vue&type=template&id=3b397e20&scoped=true&"
import script from "./ButtonC.vue?vue&type=script&lang=js&"
export * from "./ButtonC.vue?vue&type=script&lang=js&"
import style0 from "./ButtonC.vue?vue&type=style&index=0&id=3b397e20&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b397e20",
  null
  
)

export default component.exports